export const serverBaseUrl = "https://manage360-me-server.onrender.com/v1/api";

/** Razorpay Key ID for Checkout.js (publishable — server holds the secret). */
export const razorpayKeyId =
  process.env.REACT_APP_RAZORPAY_KEY_ID || "rzp_live_Sj4tJFKaoKg0eM";

export const voiceAvatarFallbackUrl =
  "https://res.cloudinary.com/dpuuciosh/image/upload/f_jpg,q_70,w_512,h_512,c_fill,g_face/v1777661021/freestocks-9UVmlIb0wJU-unsplash_esdyrg.jpg";